import { axios } from "../config";

function fetchClassrooms() {
  return axios.get("/api/v1/classrooms");
}

export { fetchClassrooms };
